























































































































































































































































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { bus } from "../../main";
import * as user from "../../_store/user.module";

@Component
export default class IspezioneCreate extends Vue {
    @Prop() infoAzienda!:any;
    private denominazioneAzienda: string;
    private personaleUno: string
    private personaleDue: string
    private ruoloUno: string
    private ruoloDue: string

    private checkUffici: boolean;
    private ambienteUfficioIdoneo: string;
    private attrezzatureUfficioIdoneo: string;
    private checkRepLavorazione: boolean;
    private ambienteRepLavorazioneIdoneo: string;
    private attrezzatureRepLavorazioneIdoneo: string;
    private checkRepAssemblaggio: boolean;
    private ambienteRepAssemblaggioIdoneo: string;
    private attrezzatureRepAssemblaggioIdoneo: string;
    private checkMagazzino: boolean;
    private ambienteMagazzinoIdoneo: string
    private attrezzatureMagazzinoIdoneo: string
    private checkSpedizioni: boolean;
    private ambienteSpedizioniIdoneo: string
    private attrezzatureSpedizioniIdoneo: string
    private checkCantiere: boolean;
    private ambienteCantiereIdoneo: string;
    private attrezzatureCantiereIdoneo: string;
    private ambientiVisitati: string; 
    private noteAmbientiVisitati: string
    private valutazioneFinale: string
    private osservazioniFinali: string

    private dateMenu: boolean;
    private timeMenu: boolean;
    private dataVisita: string;
    private oraVisita: string;
    private dateFormatted: any;


    private dataVisitaRules: [boolean | string];
    private oraVisitaRules: [boolean | string];
    private osservazioniFinaliRules: [boolean | string];
    private noteAmbientiVisitatiRules: [boolean | string];
    private personaleUnoRules: [boolean | string];
    private ruoloUnoRules: [boolean | string];

    constructor(){
        super()
        this.denominazioneAzienda = this.infoAzienda.denominazioneAzienda
        this.personaleUno = ""
        this.personaleDue = ""
        this.ruoloUno = ""
        this.ruoloDue = ""

        this.checkUffici = false
        this.ambienteUfficioIdoneo = ""
        this.attrezzatureUfficioIdoneo = ""
        this.checkRepLavorazione = false
        this.ambienteRepLavorazioneIdoneo = ""
        this.attrezzatureRepLavorazioneIdoneo = ""
        this.checkRepAssemblaggio = false
        this.ambienteRepAssemblaggioIdoneo = ""
        this.attrezzatureRepAssemblaggioIdoneo = ""
        this.checkMagazzino = false
        this.ambienteMagazzinoIdoneo = ""
        this.attrezzatureMagazzinoIdoneo = ""
        this.checkSpedizioni = false
        this.ambienteSpedizioniIdoneo = ""
        this.attrezzatureSpedizioniIdoneo = ""
        this.checkCantiere = false
        this.ambienteCantiereIdoneo = ""
        this.attrezzatureCantiereIdoneo = ""
        this.ambientiVisitati = ""
        this.noteAmbientiVisitati = ""
        this.valutazioneFinale = ""
        this.osservazioniFinali =""

        this.dateMenu = false;
        this.timeMenu = false;
        this.dataVisita = "";

        // this.dataVisita = "";
        this.oraVisita = "";
        this.dateFormatted = null;

        this.dataVisitaRules = [true];
        this.oraVisitaRules = [true];
        this.osservazioniFinaliRules = [true]
        this.noteAmbientiVisitatiRules = [true]
        this.personaleUnoRules = [true]
        this.ruoloUnoRules = [true]
    }

    @Watch("dataVisita")
    ondataChange(value: string) {
        this.dateFormatted = this.formatDate(value) 
    }

    validazioneNoteAmbientiVisitati(){
        var valid: boolean = false;
        if (this.noteAmbientiVisitati === "" || this.noteAmbientiVisitati === null) {
            this.noteAmbientiVisitatiRules = ["Motivazione necessaria"];
        } else {
            valid = /^[0-9a-zA-Zìèéùòà';:,.\x20]{2,250}$/.test(this.noteAmbientiVisitati);
            if (valid) {
                this.noteAmbientiVisitatiRules = [true];
            } else {
                this.noteAmbientiVisitatiRules = [
                "Le note non possono avere più di 250 caratteri e non deve contenere caratteri speciali e invii"
                ];
            }
        }    
    }

    validazioneOsservazioniFinali() {
        var valid: boolean = false;
        if (this.osservazioniFinali === "" || this.osservazioniFinali === null) {
            this.osservazioniFinaliRules = ["Osservazioni finali necessarie"];
        } else {
            valid = /^[0-9a-zA-Zìèéùòà';:,.\x20]{2,250}$/.test(this.osservazioniFinali);
            if (valid) {
                this.osservazioniFinaliRules = [true];
            } else {
                this.osservazioniFinaliRules = [
                "Le Osservazioni non possono avere più di 250 caratteri e non deve contenere caratteri speciali e invii"
                ];
            }
        }
    }

    validazionePersonaleUno(){
        var valid: boolean = false;
        if (this.personaleUno === "" || this.personaleUno === null) {
            this.personaleUnoRules = ["Nome e cognome necessari"];
        } else {
            valid = /^[0-9a-zA-Zìèéùòà';:,.\x20]{2,100}$/.test(this.personaleUno);
            if (valid) {
                this.personaleUnoRules = [true];
            } else {
                this.personaleUnoRules = [
                "Il nome deve avere non più di 100 caratteri e non devecontenere caratteri speciali"
                ];
            }
        } 
    }

    validazioneRuoloUno(){
        var valid: boolean = false;
        if (this.ruoloUno === "" || this.ruoloUno === null) {
            this.ruoloUnoRules = ["Ruolo necessario"];
        } else {
            valid = /^[0-9a-zA-Zìèéùòà';:,.\x20]{2,50}$/.test(this.ruoloUno);
            if (valid) {
                this.ruoloUnoRules = [true];
            } else {
                this.ruoloUnoRules = [
                "Il ruolo deve avere non più di 50 caratteri e non devecontenere caratteri speciali"
                ];
            }
        }     
    }

    validazioneDataVisita() {
        if (this.dataVisita !== "") {
            this.dataVisitaRules = [true];
        } else {
            this.dataVisitaRules = ["Data visita necessaria"];
        }
    }

    validazioneOraVisita() {
        if (this.oraVisita !== "") {
        this.oraVisitaRules = [true];
        } else {
        this.oraVisitaRules = ["Ora visita necessaria"];
        }
    }

    validazioneUffici(): boolean{
        var valid: boolean = false
        if(this.checkUffici){
            if(this.ambienteUfficioIdoneo !== "" && this.attrezzatureUfficioIdoneo !== ""){
                valid = true
            }
        }else {
            valid = true
        }
        return valid
    }

    validazioneRepartiLavorazione(): boolean{
        var valid: boolean = false
        if(this.checkRepLavorazione){
            if(this.ambienteRepLavorazioneIdoneo !== "" && this.attrezzatureRepLavorazioneIdoneo !== ""){
                valid = true
            }
        }else {
            valid = true
        }
        return valid
    }

    validazioneRepartiAssemblaggio(): boolean{
        var valid: boolean = false
        if(this.checkRepAssemblaggio){
            if(this.ambienteRepAssemblaggioIdoneo !== "" && this.attrezzatureRepAssemblaggioIdoneo !== ""){
                valid = true
            }
        }else {
            valid = true
        }
        return valid
    }

    validazioneMagazzino(): boolean{
        var valid: boolean = false
        if(this.checkMagazzino){
            if(this.ambienteMagazzinoIdoneo !== "" && this.attrezzatureMagazzinoIdoneo !== ""){
                valid = true
            }
        }else {
            valid = true
        }
        return valid
    }

    validazioneSpedizioni(): boolean{
        var valid: boolean = false
        if(this.checkSpedizioni){
            if(this.ambienteSpedizioniIdoneo !== "" && this.attrezzatureSpedizioniIdoneo !== ""){
                valid = true
            }
        }else {
            valid = true
        }
        return valid
    }

    validazioneCantiere(): boolean{
        var valid: boolean = false
        if(this.checkCantiere){
            if(this.ambienteCantiereIdoneo !== "" && this.attrezzatureCantiereIdoneo !== ""){
                valid = true
            }
        }else {
            valid = true
        }
        return valid
    }

    validazioneSpunte(): boolean{
        var valid: boolean = false
        valid = this.validazioneUffici()
        valid = this.validazioneRepartiLavorazione()
        valid = this.validazioneRepartiAssemblaggio()
        valid = this.validazioneMagazzino()
        valid = this.validazioneSpedizioni()
        valid = this.validazioneCantiere()
        if(valid){
            if(this.ambientiVisitati === ""){
                valid = false
            }
            if(this.valutazioneFinale === ""){
                valid = false
            }
        }else{
            valid = false
        }
        return valid
    }

    clearTutorSignature() {
        //@ts-ignore
        this.$refs.tutorSignaturePad.clearSignature();
    }

    format_date(date: any){
        if(!date){
            return
        }
        let [year, month, day] = date.split("-");
        return day + "/" + month + "/" + year;

    }

    formatDate (date: any) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
    }

    async executeTest() {
        this.validazioneDataVisita();
        this.validazioneOraVisita();
        this.validazioneOsservazioniFinali()
        this.validazionePersonaleUno()
        this.validazioneRuoloUno()
        if(this.ambientiVisitati === 'false'){
            this.validazioneNoteAmbientiVisitati()
        }else{
            this.noteAmbientiVisitatiRules = [true]
        }
    }

    close() {
        bus.$emit("closeCreateDialog");
    }

    save(){
        var ambienteUfficioIdoneo: boolean;
        var attrezzatureUfficioIdoneo: boolean;
        var ambienteRepLavorazioneIdoneo: boolean;
        var attrezzatureRepLavorazioneIdoneo: boolean;
        var ambienteRepAssemblaggioIdoneo: boolean;
        var attrezzatureRepAssemblaggioIdoneo: boolean;
        var ambienteMagazzinoIdoneo: boolean;
        var attrezzatureMagazzinoIdoneo: boolean;
        var ambienteSpedizioniIdoneo: boolean;
        var attrezzatureSpedizioniIdoneo: boolean;
        var ambienteCantiereIdoneo: boolean;
        var attrezzatureCantiereIdoneo: boolean;
        var ambientiVisitati: boolean;
        var valutazioneFinale: boolean;

        this.executeTest().then(() =>{
            if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
                if (this.validazioneSpunte()){
                    //@ts-ignore
                    const signatureTutor = this.$refs.tutorSignaturePad.saveSignature();
                    if(signatureTutor.isEmpty === false){
                        if (this.ambienteUfficioIdoneo === "false" || this.ambienteUfficioIdoneo === "") {
                            ambienteUfficioIdoneo = false;
                        } else {
                            ambienteUfficioIdoneo = true;
                        }

                        if (this.attrezzatureUfficioIdoneo === "false" || this.attrezzatureUfficioIdoneo === "") {
                            attrezzatureUfficioIdoneo = false;
                        } else {
                            attrezzatureUfficioIdoneo = true;
                        }

                        if (this.ambienteRepLavorazioneIdoneo === "false" || this.ambienteRepLavorazioneIdoneo === "") {
                            ambienteRepLavorazioneIdoneo = false;
                        } else {
                            ambienteRepLavorazioneIdoneo = true;
                        }

                        if (this.attrezzatureRepLavorazioneIdoneo === "false" || this.attrezzatureRepLavorazioneIdoneo === "") {
                            attrezzatureRepLavorazioneIdoneo = false;
                        } else {
                            attrezzatureRepLavorazioneIdoneo = true;
                        }

                        if (this.ambienteRepAssemblaggioIdoneo === "false" || this.ambienteRepAssemblaggioIdoneo === "") {
                            ambienteRepAssemblaggioIdoneo = false;
                        } else {
                            ambienteRepAssemblaggioIdoneo = true;
                        }

                        if (this.attrezzatureRepAssemblaggioIdoneo === "false" || this.attrezzatureRepAssemblaggioIdoneo === "") {
                            attrezzatureRepAssemblaggioIdoneo = false;
                        } else {
                            attrezzatureRepAssemblaggioIdoneo = true;
                        }

                        if (this.ambienteMagazzinoIdoneo === "false" || this.ambienteMagazzinoIdoneo === "") {
                            ambienteMagazzinoIdoneo = false;
                        } else {
                            ambienteMagazzinoIdoneo = true;
                        }

                        if (this.attrezzatureMagazzinoIdoneo === "false" || this.attrezzatureMagazzinoIdoneo === "") {
                            attrezzatureMagazzinoIdoneo = false;
                        } else {
                            attrezzatureMagazzinoIdoneo = true;
                        }

                        if (this.ambienteSpedizioniIdoneo === "false" || this.ambienteSpedizioniIdoneo === "") {
                            ambienteSpedizioniIdoneo = false;
                        } else {
                            ambienteSpedizioniIdoneo = true;
                        }

                        if (this.attrezzatureSpedizioniIdoneo === "false" || this.attrezzatureSpedizioniIdoneo === "") {
                            attrezzatureSpedizioniIdoneo = false;
                        } else {
                            attrezzatureSpedizioniIdoneo = true;
                        }

                        if (this.ambienteCantiereIdoneo === "false" || this.ambienteCantiereIdoneo === "") {
                            ambienteCantiereIdoneo = false;
                        } else {
                            ambienteCantiereIdoneo = true;
                        }

                        if (this.attrezzatureCantiereIdoneo === "false" || this.attrezzatureCantiereIdoneo === "") {
                            attrezzatureCantiereIdoneo = false;
                        } else {
                            attrezzatureCantiereIdoneo = true;
                        }

                        if (this.ambientiVisitati === "false") {
                            ambientiVisitati = false;
                        } else {
                            ambientiVisitati = true;
                        }

                        if (this.valutazioneFinale === "false") {
                            valutazioneFinale = false;
                        } else {
                            valutazioneFinale = true;
                        }

                        var userInfo = user.readUserInfo(this["$store"]);
                        var infoIspezione: any = {
                            dataIspezione: this.dataVisita,
                            oraIspezione: this.oraVisita,
                            idAzienda: this.infoAzienda.idAzienda,
                            checkUffici: this.checkUffici,
                            ambienteUfficioIdoneo: ambienteUfficioIdoneo,
                            attrezzatureUfficioIdoneo: attrezzatureUfficioIdoneo,
                            checkRepLavorazione: this.checkRepLavorazione,
                            ambienteRepLavorazioneIdoneo: ambienteRepLavorazioneIdoneo,
                            attrezzatureRepLavorazioneIdoneo: attrezzatureRepLavorazioneIdoneo,
                            checkRepAssemblaggio: this.checkRepAssemblaggio,
                            ambienteRepAssemblaggioIdoneo: ambienteRepAssemblaggioIdoneo,
                            attrezzatureRepAssemblaggioIdoneo: attrezzatureRepAssemblaggioIdoneo,
                            checkMagazzino: this.checkMagazzino,
                            ambienteMagazzinoIdoneo: ambienteMagazzinoIdoneo,
                            attrezzatureMagazzinoIdoneo: attrezzatureMagazzinoIdoneo,
                            checkSpedizioni: this.checkSpedizioni,
                            ambienteSpedizioniIdoneo: ambienteSpedizioniIdoneo,
                            attrezzatureSpedizioniIdoneo: attrezzatureSpedizioniIdoneo,
                            checkCantiere: this.checkCantiere,
                            ambienteCantiereIdoneo: ambienteCantiereIdoneo,
                            attrezzatureCantiereIdoneo: attrezzatureCantiereIdoneo,
                            ambientiVisitati: ambientiVisitati,
                            noteAmbientiVisitati: this.noteAmbientiVisitati,
                            valutazioneFinale: valutazioneFinale,
                            osservazioniFinali: this.osservazioniFinali,
                            firmaIspettore: signatureTutor.data,
                            personaleUno: this.personaleUno,
                            personaleDue: this.personaleDue,
                            ruoloUno: this.ruoloUno,
                            ruoloDue: this.ruoloDue,
                            idUtenteIstituto: userInfo.idUtente,
                            idIstituto: userInfo.codEntità
                        }

                        user.dispatchCreateIspezione(this["$store"], infoIspezione)
                        .then(() => {
                            bus.$emit(
                                "successfullOperation",
                                "Ispezione creata con successo"
                            );
                            this.close()
                        }).catch(error => {
                            if (error.response.status === 403) {
                                bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                                this["$router"].push("/login");
                            } else {
                                bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                            }
                        });

                    }else{
                        bus.$emit("errorOperation", "Firma mancante");     
                    }
                } else {
                    bus.$emit("errorOperation", "Controllare compilazione campi report"); 
                }   
            }    
        })
    }
    created(){
        this.dataVisita = new Date().toISOString().substr(0, 10)
    }
} 
